import config from '@/config';
import { requests } from '.';
const CONTENT_AI_SERVICE_URL = config === null || config === void 0 ? void 0 : config.CONTENT_AI_SERVICE_URL;
export const ContentAIServices = {
    generateVariations: (body) => requests(CONTENT_AI_SERVICE_URL).post('/content/posts', body),
    getSummary: (locationId) => requests(CONTENT_AI_SERVICE_URL).get(`/content/usage/summary?locationId=${locationId}`),
    getTransactions: (params) => requests(CONTENT_AI_SERVICE_URL).get('/content/usage/transactions', {
        params,
    }),
    getVariationsById: (id, locationId) => requests(CONTENT_AI_SERVICE_URL).get(`/content/posts/${id}?locationId=${locationId}`),
    updateContentById: (id, body) => requests(CONTENT_AI_SERVICE_URL).put(`/content/socialmedia/posts/${id}`, body),
    getAllImagePresets: (locationId) => requests(CONTENT_AI_SERVICE_URL).get(`/content/images/presets/all?locationId=${locationId}`),
    generateImageVariations: (body) => requests(CONTENT_AI_SERVICE_URL).post('/content/images', body),
    getImageVariationsById: (id, locationId) => requests(CONTENT_AI_SERVICE_URL).get(`/content/images/${id}?locationId=${locationId}`),
    updateImageById: (id, body) => requests(CONTENT_AI_SERVICE_URL).put(`/content/images/${id}`, body),
    getImageSummary: (locationId) => requests(CONTENT_AI_SERVICE_URL).get(`/content/usage/images/summary?locationId=${locationId}`),
    getImageTransactions: (params) => requests(CONTENT_AI_SERVICE_URL).get('/content/usage/images/transactions', {
        params,
    }),
    generateQuickAction: (body) => requests(CONTENT_AI_SERVICE_URL).post('/content/contextual', body),
    getQuickActionSession: (sessionId) => requests(CONTENT_AI_SERVICE_URL).get(`/content/contextual/${sessionId}`),
    updateQuickActionUsed: (sessionId, body) => requests(CONTENT_AI_SERVICE_URL).put(`/content/contextual/${sessionId}`, body),
};
